export interface TonBridgersTransactionData {
    address: string;
    amount: string;
    payload: string;
}
